import styled from '@emotion/styled';
import { DependentInfoItem } from './DependentInfoItem';
import { token } from '@ferreri/prever-component-lib';

type DependentInfoContentProps = {
  id: number | string;
  min_age: number | null;
  max_age: number | null;
  showAbsolute: boolean;
  showRelative: boolean;
  relative_price: number;
  absolute_price: number;
  marital_status: string;
};

export const DependentInfoContent = (props: DependentInfoContentProps) => {
  return (
    <Wrapper key={props?.id}>
      {Boolean(props?.max_age) && Boolean(props?.min_age) && (
        <DependentInfoItem
          label={`Entre ${props?.min_age} e ${props?.max_age} anos`}
          showAbsolute={props?.showAbsolute}
          showRelative={props?.showRelative}
          relative_price={props?.relative_price}
          absolute_price={props?.absolute_price}
        />
      )}
      {Boolean(props?.max_age) && !props?.min_age && (
        <DependentInfoItem
          label={`Até ${props?.max_age} anos`}
          showAbsolute={props?.showAbsolute}
          showRelative={props?.showRelative}
          relative_price={props?.relative_price}
          absolute_price={props?.absolute_price}
        />
      )}
      {Boolean(props?.min_age) && !props?.max_age && (
        <DependentInfoItem
          label={`A partir de ${props?.min_age} anos`}
          showAbsolute={props?.showAbsolute}
          showRelative={props?.showRelative}
          relative_price={props?.relative_price}
          absolute_price={props?.absolute_price}
        />
      )}
      {!props?.min_age && !props?.max_age && (
        <DependentInfoItem
          label="Mensalidade"
          showAbsolute={props?.showAbsolute}
          showRelative={props?.showRelative}
          relative_price={props?.relative_price}
          absolute_price={props?.absolute_price}
        />
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingXxxSmall};
  justify-content: center;
`;
